'use strict';

const Marionette = require('backbone.marionette');

export default Marionette.View.extend({
  template: require('./templates/text-area.hbs'),
  className: 'custom-form-question',
  ui: {
    textarea: 'textarea',
  },
  events: {
    'change @ui.textarea': 'onChange',
  },

  onChange() {
    this.model.set('value', this.ui.textarea.val());
  },
});
